var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "proxy openapi" },
    [
      _c("sec-title", {
        attrs: {
          isShowHelp: false,
          title: _vm.hasKey
            ? _vm.$t("trade.openapi.myKey")
            : _vm.$t("trade.openapi.title")
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "__form_border" }, [
        _vm.hasKey
          ? _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "__form_input_title" }, [
                  _vm._v(" " + _vm._s(_vm.$t("trade.openapi.createTime")) + " ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "__form__input_content" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("date")(_vm.apiInfo.createTime, _vm.$i18n.locale)
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "__form_input_title" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("trade.openapi.permissions")) + " "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "__form__input_content permissions" },
                  _vm._l(_vm.permissions, function(pair) {
                    return _c("pair-item", {
                      key: pair,
                      attrs: { item: { name: pair } }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "click-able __small_btn",
                    on: {
                      click: function($event) {
                        return _vm._addProxy("add")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("trade.proxy.active.operate.0")) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "click-able __small_btn",
                    on: {
                      click: function($event) {
                        return _vm._addProxy("delete")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("trade.proxy.active.operate.1")) +
                        "\n                "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "__form_input_title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("trade.openapi.keyConfirm.accessKey")) +
                      " "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "__form__input_content permissions" },
                  [_vm._v(" " + _vm._s(_vm.apiInfo.apiKey) + " ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "__form_input_title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("trade.openapi.keyConfirm.agentAddress")) +
                      " "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "__form__input_content permissions" },
                  [_vm._v(" " + _vm._s(_vm.agentAddress) + " ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "__form_input_title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("trade.openapi.agentAddressStakingAmount")
                      ) +
                      " "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "__form__input_content staking-amount" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm._f("formatNum")(
                            _vm.apiInfo.agentPledgeAmount || 0,
                            18,
                            0
                          )
                        ) +
                        " dSLS\n                    "
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "__small_btn",
                        on: { click: _vm._goStaking }
                      },
                      [_vm._v(_vm._s(_vm.$t("trade.openapi.staking")))]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "__form_input_title" }, [
                  _vm._v(_vm._s(_vm.$t("trade.openapi.package")))
                ]),
                _vm._v(" "),
                _vm.packageInfo
                  ? _c(
                      "div",
                      { staticClass: "__form__input_content package" },
                      [
                        _c(
                          "package-info",
                          { attrs: { data: _vm.packageInfo, upgrade: true } },
                          [
                            _vm.canUpgrade
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "__small_btn",
                                    on: { click: _vm._goUpgrade }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("trade.openapi.upgrade"))
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.apiInfo.expireTime
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "__form_input_title" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("trade.openapi.expireTime")) + " "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "__form__input_content permissions" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("date")(
                                _vm.apiInfo.expireTime,
                                this.$i18n.locale
                              )
                            ) +
                            " "
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "create-open-api __form_btn __pointer",
                    class: { unuse: _vm.pending },
                    on: { click: _vm._deleteApiKey }
                  },
                  [_vm._v(_vm._s(_vm.$t("trade.openapi.deleteKey")))]
                )
              ])
            ])
          : _c("div", { staticClass: "item" }, [
              _vm.balanceNotEnough
                ? _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("tips", { attrs: { type: "warn" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("trade.openapi.balanceAlert", {
                              balanceLimit: this.balanceLimit
                            })
                          )
                        )
                      ])
                    ],
                    1
                  )
                : _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "create-open-api __form_btn __pointer",
                        class: { unuse: _vm.pending },
                        on: { click: _vm._createApiKey }
                      },
                      [_vm._v(_vm._s(_vm.$t("trade.openapi.createKey")))]
                    )
                  ])
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "item right tips-wrapper" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("div", { staticClass: "__form_input_title" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("trade.openapi.tips.title")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _vm._l([0, 1, 2, 3], function(item, index) {
                return _c("div", { key: index }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("trade.openapi.tips." + index)) +
                      "\n                    "
                  ),
                  index === 0
                    ? _c(
                        "ul",
                        _vm._l([1, 2, 3, 4], function(_item, index) {
                          return _c("li", {
                            key: index,
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("trade.openapi.tips.0-step" + _item)
                              )
                            }
                          })
                        }),
                        0
                      )
                    : _vm._e()
                ])
              })
            ],
            2
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }